import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-archetype-report-unavailable-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './archetype-report-unavailable-modal.component.html',
})
export class ArchetypeReportUnavailableModalComponent {
  @Input() firstName: string = '';

  constructor(public bsModalRef: BsModalRef) {}

  close(): void {
    this.bsModalRef.hide();
  }
}
